<template>
  <v-container id="auth" fluid tag="section">
    <v-row align="center" justify="center">
      <v-col style="max-width: 500px">
        <base-card class="px-md-5" :loading="isLoading">
          <v-card-title>
            <div><span v-t="'Sign in'" /></div>
          </v-card-title>
          <v-card-text>
            <v-text-field
              required
              type="text"
              v-model="username"
              :label="$t('Username')"
            ></v-text-field>
            <v-text-field
              required
              type="password"
              v-model="password"
              :label="$t('Passsword')"
            ></v-text-field>
            <div class="d-flex justify-end">
              <base-btn color="primary" @click="authenticate" :loading="isLoading">
                <span v-t="'Sign in'" />
              </base-btn>
            </div>
            <v-alert type="error" class="mt-5" v-if="errorMessage">
              {{ errorMessage }}
            </v-alert>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: null,
      isLoading: false,
      username: "",
      password: "",
    };
  },
  methods: {
    async authenticate() {
      this.isLoading = true;
      try {
        const response = await this.axios.post("/authenticate", {
          username: this.username,
          password: this.password,
        });
        this.errorMessage = null;
        location.reload();
        // if (response.data.is_admin === true) this.$store.commit("SET", { is_admin: true });
      } catch (error) {
        console.log("error", error);
        this.errorMessage = error.response.data.message;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
</style>
